import {
  Button,
  Dialog,
  DialogBody,
  Typography,
} from '@material-tailwind/react';
import { useFreeTrialExternalLinks } from '../../../hooks/useFreeTrialExternalLink';

interface FreeTrialUnavailableModalProps {
  open: boolean;
  onClose: () => void;
}

const FreeTrialUnavailableModal = ({
  open,
  onClose,
}: FreeTrialUnavailableModalProps) => {
  const links = useFreeTrialExternalLinks();

  const handleClickInquiry = () => {
    window.open(links.FREE_TRIAL_KAKAO, '_blank');
    onClose();
  };

  return (
    <Dialog
      open={open}
      handler={onClose}
      size="xs"
      className="m-4 w-[calc(100%-32px)] rounded-[20px] md:m-auto md:w-[400px]"
    >
      <DialogBody className="px-6 py-7">
        <div className="flex flex-col items-center">
          <Typography className="text-center text-[18px] font-extrabold leading-7 text-gray-900">
            이미 무료체험 신청 횟수를
            <br />
            모두 사용했어요
          </Typography>

          <Typography className="mt-3 text-center text-[13px] leading-5 text-gray-700">
            고객센터로 문의해 주세요.
          </Typography>

          <Button
            ripple={false}
            onClick={handleClickInquiry}
            className="mt-6 h-11 w-full rounded-xl bg-[#FEE500] py-0 text-sm font-bold normal-case text-black shadow-none hover:bg-[#FDDC00] hover:shadow-none"
          >
            카카오톡으로 상담하기
          </Button>
        </div>
      </DialogBody>
    </Dialog>
  );
};

export default FreeTrialUnavailableModal;
